import React from "react";
import { Inbox } from "lucide-react";

const EmptyState = ({ title = "Nothing here yet", description, icon: Icon = Inbox, action }) => (
  <div data-testid="empty-state" className="flex flex-col items-center justify-center text-center py-12 px-4">
    <div className="h-12 w-12 rounded-full bg-muted flex items-center justify-center mb-3">
      <Icon className="h-6 w-6 text-muted-foreground" />
    </div>
    <div className="font-display font-semibold">{title}</div>
    {description && <p className="mt-1 text-sm text-muted-foreground max-w-md">{description}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export default EmptyState;
